"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VIDEO_PLAY_BUTTON = exports.VIDEO_PLAYER = exports.VIDEO = exports.PAGINATION_STEP = exports.IMAGE_PLACEHOLDER_BACKGROUND = exports.IMAGE_PLACEHOLDER = exports.IMAGE = exports.FONT_SANS_ORI = exports.CAROUSEL_WRAPPER = exports.CAROUSEL_SLIDE = exports.CAROUSEL_PREVIOUS_ARROW = exports.CAROUSEL_NEXT_ARROW = exports.CAROUSEL = void 0;
const FONT_SANS_ORI = exports.FONT_SANS_ORI = 'SansOri, SansOriFallback, sans-serif';
const CAROUSEL = exports.CAROUSEL = 'Carousel';
const CAROUSEL_WRAPPER = exports.CAROUSEL_WRAPPER = 'CarouselWrapper';
const CAROUSEL_PREVIOUS_ARROW = exports.CAROUSEL_PREVIOUS_ARROW = 'CarouselPreviousArrow';
const CAROUSEL_NEXT_ARROW = exports.CAROUSEL_NEXT_ARROW = 'CarouselNextArrow';
const CAROUSEL_SLIDE = exports.CAROUSEL_SLIDE = 'CarouselSlide';
const IMAGE = exports.IMAGE = 'Image';
const VIDEO = exports.VIDEO = 'VideoWrapper';
const VIDEO_PLAY_BUTTON = exports.VIDEO_PLAY_BUTTON = 'VideoPlayButton';
const VIDEO_PLAYER = exports.VIDEO_PLAYER = 'VideoPlayer';
const IMAGE_PLACEHOLDER = exports.IMAGE_PLACEHOLDER = 'ImagePlaceholder';
const IMAGE_PLACEHOLDER_BACKGROUND = exports.IMAGE_PLACEHOLDER_BACKGROUND = 'ImagePlaceholderBackground';
const PAGINATION_STEP = exports.PAGINATION_STEP = 'PaginationStep';
